import metadata from './metadata.json'

const configs = { metadata }

export default configs
